import { useMemo } from 'react';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller';
import { getSetOfProductsAvailable } from '../index';

const useAvailableProducts = () => {
	const { licensedProducts } = useTenantContext();
	const availableProducts = useMemo(
		() => getSetOfProductsAvailable(licensedProducts),
		[licensedProducts],
	);

	return { availableProducts };
};
export default useAvailableProducts;
